var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeServicesNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8139_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36104 0.140652L14.8467 2.65677L15.4468 2.88806L15.4843 3.52881C15.5749 5.09162 15.3312 7.47646 14.3185 9.80817C13.2964 12.1586 11.471 14.4966 8.39855 15.8281L8.00159 16L7.60464 15.8281C4.52591 14.4997 2.70368 12.1649 1.68161 9.81129C0.668912 7.47959 0.425114 5.09162 0.515757 3.53194L0.553264 2.89119L1.15338 2.65677L7.63902 0.140652L7.99847 0L8.36104 0.140652ZM1.51283 3.59133C1.34717 6.44188 2.413 12.4962 7.99847 14.9123C13.5871 12.4962 14.6529 6.44188 14.4872 3.59133L7.99847 1.07208L1.51283 3.59133ZM11.196 5.5042L10.9022 5.9074L7.60152 10.4458L7.25145 10.9271L6.83887 10.4989L5.13853 8.73921L4.79159 8.37976L5.51048 7.68588C5.5855 7.76402 6.12935 8.32663 7.14518 9.37683L10.0958 5.31979L10.3896 4.91659L11.1991 5.5042H11.196Z",
    fill: "#3B6CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8139_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeServicesNotificationIcon);
export default __webpack_public_path__ + "static/media/home-services-notification-icon.a06d30e553d099389c052d55d7e7ad08.svg";
export { ForwardRef as ReactComponent };